// Chile-style formatting: DD-MM-YYYY, 24h time, decimal comma for temperatures.

export function fmtTemp(value, unit = "C") {
  if (value === null || value === undefined || value === "") return "—";
  const n = Number(value);
  if (Number.isNaN(n)) return "—";
  return `${n.toFixed(1).replace(".", ",")} °${unit}`;
}

export function parseTempInput(str) {
  if (str === null || str === undefined) return null;
  const n = Number(String(str).replace(",", "."));
  return Number.isNaN(n) ? null : n;
}

function toDate(v) {
  if (!v) return null;
  const d = typeof v === "string" ? new Date(v) : v;
  return Number.isNaN(d.getTime()) ? null : d;
}

export function fmtDate(v) {
  const d = toDate(v);
  if (!d) return "—";
  const p = (n) => String(n).padStart(2, "0");
  return `${p(d.getDate())}-${p(d.getMonth() + 1)}-${d.getFullYear()}`;
}

export function fmtTime(v) {
  const d = toDate(v);
  if (!d) return "—";
  const p = (n) => String(n).padStart(2, "0");
  return `${p(d.getHours())}:${p(d.getMinutes())}`;
}

export function fmtDateTime(v) {
  const d = toDate(v);
  if (!d) return "—";
  return `${fmtDate(d)} ${fmtTime(d)}`;
}

export function elapsed(v) {
  const d = toDate(v);
  if (!d) return "—";
  const mins = Math.floor((Date.now() - d.getTime()) / 60000);
  if (mins < 1) return "recién";
  if (mins < 60) return `hace ${mins} min`;
  const h = Math.floor(mins / 60);
  if (h < 24) return `hace ${h} h`;
  return `hace ${Math.floor(h / 24)} d`;
}

export const WEEKDAYS = [
  { value: 1, label: "Lun" }, { value: 2, label: "Mar" }, { value: 3, label: "Mié" },
  { value: 4, label: "Jue" }, { value: 5, label: "Vie" }, { value: 6, label: "Sáb" },
  { value: 7, label: "Dom" },
];
